import icons from "../icons";

const userDropdownConfigs = [
  {
    title: "سطح کاربری",
    type: "button",
    modalToOpen: "ranks",
    icon: icons.rank,
  },
  {
    title: "حساب کاربری",
    type: "link",
    link: "/panel/dashboard",
    icon: icons.user,
  },
  {
    title: "پیام‌ها",
    type: "link",
    link: "/panel/notifications",
    icon: icons.notifications,
  },
  {
    title: "خروج",
    type: "button",
    modalToOpen: "logout",
    icon: icons.logout,
  },
];

export default userDropdownConfigs;
